export const isObjTrue = (value: unknown): boolean => {
  if (value === undefined || value === null) return false

  return /^(?:y|yes|true|t|1|on)$/i.test(String(value).trim())
}
